<template >
  <section class="title">
    <div class="title__texture"></div>
    <div class="title__text-container">
      <div class="container">
        <div class="row title__row">
          <div class="col-5 title__column">
            <div class="title__title-wrapper">
              <BigTitle />
            </div>
          </div>
          <div class="col-3 title__column"></div>
          <div class="col-4 title__column">
            <div class="title__paragraphs">
              <paragraph v-for="paragraph in titleData.introText" :paragraph="paragraph" />
              <div class="title__instruction-wrapper">
                <instructions />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script >
import titleData from "../assets/json-data/twelveByOneData";
import Paragraph from "@/components/twelve-by-one-specific-components/Paragraphs";
import BigTitle from "@/components/twelve-by-one-specific-components/BigTitle";
import Instructions from "@/components/twelve-by-one-specific-components/Instructions";
export default {
  name: "title-large",
  components: { Paragraph, BigTitle, Instructions },
  data() {
    return {
      titleData
    };
  }
};
</script>

<style scoped lang="scss">
@import "../styles/_vars";
.title {
  height: 100vh;
  width: 100vw;

  background: linear-gradient(270deg, #7f35b2, #0191da, #78be20);
  background-size: 1000% 1000%;
  animation: gradientRippler 5s ease-in-out infinite alternate;

  &__texture {
    width: 100%;
    height: 100%;
    background-image: url("../assets/twelve-by-one-assets/texture.svg");
    background-size: 12%;
    mix-blend-mode: multiply;
  }
  &__text-container {
    position: absolute;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
  }
  &__row {
    height: 100vh;
    mix-blend-mode: normal;
    color: $color-white;
  }
  &__column {
    height: 100%;
    position: relative;
  }
  &__title-wrapper {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
  }

  &__paragraphs {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    width: 100%;
  }
  &__instruction-wrapper {
    margin-top: 85px;
  }
}
</style>
